import React from "react";
import moment from "moment";
import saveAs from "file-saver";
import { useMemo, useState } from "react";
import Loader from "react-loader-spinner";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import InvoiceModal from "./Modals/InvoiceModal";
import AccountHeading from "./AccountHeading";
import IconComponent from "./IconComponent";
import { connect } from "react-redux";
import AllSubscriptions from './AllSubscription';
import { windowOpen } from "../../../../../utils";
import { DOWNLOAD_INVOICE_PDF } from "../../../../../actions/accountsActions";
import { togglePlanSection_D } from "../../../../../actions/showDisplayModalAction";
import { FontAwesomeIcon } from "../../../../CommonComponents/AssetsHelper";
import { PRODUCT_SUBSCRIPTION_CANCELANCELLATION } from "../../../../../reducers/keys";

const ProductSubscription = ({ productDetails, userData, widgetAddon, ugcAddon, changePlan, handleParentStatus, productCancellation }) => {
  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceInfo, setInvoiceInfo] = useState([]);

  const [downloadLoading, setdownloadLoading] = useState(0);
  const [invoiceId, setinvoiceId] = useState([]);
  const [downloadStatus, setdownloadStatus] = useState(0);

  const openInvoicePopup = (item) => {
    setInvoiceInfo(item);
    setShowInvoice(true);
  };

  const closeInvoicePopup = () => {
    setShowInvoice(false);
    setInvoiceInfo([]);
  };

  const downloadInvoicePDF = (invoiceid, invoiceId2, status = 0) => event => {
    setdownloadLoading(status ? 2 : 1);
    invoiceId.push(invoiceid)
    setdownloadStatus(downloadStatus + 1)

    DOWNLOAD_INVOICE_PDF(invoiceid)
      .then((response) => {
        const file = new Blob([response.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        saveAs(file, `Invoice-${invoiceId2}.pdf`);

        if (invoiceId && invoiceId.length > 0) {
          invoiceId.splice(0, 1);
        }

        setdownloadLoading(invoiceId.length > 0 ? 1 : 0);
        setdownloadStatus(downloadStatus + 1)
      })
      .catch((error) => {
        console.error("pdfAnalyticGenerate issue", error);
        setdownloadLoading(false);
        setdownloadStatus(0);
        setinvoiceId(0);
      });
  };

  const previewInvoice = (invoice, type) => {
    if (type == "download") {
      if (invoice.hosteddownloadurl) windowOpen(invoice.hosteddownloadurl, "_blank");
      else downloadInvoicePDF(invoice?.invoiceId ?? "", invoice?.invoiceView?.invoiceId ?? "")();
    } else {
      if (invoice.hostedurl) windowOpen(invoice.hostedurl, "_blank");
      else openInvoicePopup(invoice);
    }
  }
  
  return (
    <>
      <AccountHeading title={"All Subscription"} />

      <AllSubscriptions {...{invoiceId, downloadLoading, previewInvoice, productDetails, changePlan, handleParentStatus, productCancellation }} cardData={userData?.user?.cardDetails?.length > 0 ? JSON.parse(userData?.user?.cardDetails) ?? null : null}  />

      <BillingTab planData={widgetAddon} tabId={"widgetSubscriptionAccordion"} {...{downloadInvoicePDF, invoiceId, changePlan, downloadLoading, openInvoicePopup }} />

      <BillingTab planData={ugcAddon} tabId={"ugcSubscriptionAccordion"} {...{downloadInvoicePDF, invoiceId, changePlan, downloadLoading, openInvoicePopup }} />

      <InvoiceModal
        showInvoice={showInvoice}
        invoiceInfo={invoiceInfo}
        downloadInvoicePDF={downloadInvoicePDF}
        closeInvoicePopup={closeInvoicePopup}
        downloadLoading={downloadLoading}
        invoiceId={invoiceId}
        userData={userData} />

    </>
  );
};
const mapStateToProps = (state) => {
  return {
    savedCards: state.userAccountData.savedCards,
    userData: state.authenticated.userData
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changePlan: () => dispatch(togglePlanSection_D(true)),
    productCancellation: (item) => dispatch({ type: PRODUCT_SUBSCRIPTION_CANCELANCELLATION, payload: item })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSubscription);


const BillingTab = ({ planData, tabId, downloadInvoicePDF, invoiceId, changePlan, downloadLoading, openInvoicePopup }) => {

  const hideDropDownArrow = useMemo(() => {
    if (planData?.length > 0) {
      for (let curr of planData) {
        if (curr && Object.keys(curr).length > 0 && curr.invoices.length > 0) return false;
        return true;
      }
    }
    return true;
  }, [planData])

  return planData?.length ? <>
    <AccountHeading title={`Socialwalls Addon Subscription`} />
    <div className="subscription-plan-table table-responsive bg-white rounded accordion mb-8" id={tabId}>
      <Table className="plan_sub_table mb-0">
        <thead>
          <tr>
            <th>Addon Plan</th>
            <th>Pricing</th>
            <th>Feeds Qty.</th>
            <th>Expiry at</th>
            <th>Status</th>
            <th style={{ minWidth: "182px", textAlign: "right" }}>Plan Action</th>
          </tr>
        </thead>
      </Table>

      {planData.map((item, index) => (
        <React.Fragment key={index}>
          <div className="accordion-item border-0">
            <Table className="plan_sub_table m-0">
              <tbody>
                <tr>
                  <td>
                    <div className="d-flex align-items-center flex-nowrap">
                      {!hideDropDownArrow ? <div className="flex-shrink-0 me-4" id="headingOne">
                        {item?.invoices?.length > 0 ? (
                          <button className="accordion-link me-4 p-0 bg-transparent shadow-none accoudion-arrow border-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#allInvoice_of_w${index}`} aria-expanded="false" aria-controls="accordion" >
                            <IconComponent class_name={"svg-icon svg-icon-md"} >
                              <FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={''} />
                            </IconComponent>
                          </button>
                        ) : null}
                      </div> : null}
                      <div className="flex-shrink-0 me-4">
                        <div className="symbol symbol-35">
                          <img className="img-fluid" src={item?.Product?.[0]?.logo} height={35} width={35} alt="" />
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between flex-wrap mt-2">
                        <div className="me-3">
                          <h5 className="d-flex align-items-center font-weight-bold">
                            {item?.Product?.[0]?.name}
                          </h5>
                          <span className="font-weight-normal">
                            {item?.userProduct?.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td><p className="text-dark-75 m-0">${item?.userProduct?.amountValue}</p></td>
                  <td>{item?.userProduct?.addon_feeds}</td>
                  <td>
                    <div className="d-flex flex-column text-left">
                      <p className="mb-0">
                        {item.userProduct.endDate && item.userProduct.endDate != '' ? item.userProduct.endDate : item.userProduct.expiresAt > 0 ? moment.unix(item.userProduct.expiresAt).format("Do MMM YYYY") : `--`}
                      </p>
                    </div>
                  </td>
                  <td>
                    {item.userProduct.expiresAt > 0 ? (
                      moment(new Date(), "YYYY.MM.DD").unix() < item.userProduct.expiresAt ? (<span className="label font-weight-bold label-xl label-inline label-light-success plan_status"> Active </span>) : (<span className="label font-weight-bold label-xl label-inline label-light-warning plan_status"> Expired </span>)
                    ) : (<span className="label font-weight-bold label-xl label-inline label-light-success plan_status"> Active </span>)}
                  </td>

                  <td style={{ minWidth: "182px", textAlign: "right" }} align={"right"}>
                    {item.userProduct.cancelSubscription == 0 ? <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Remove</Tooltip>}>
                      <button type="button" className="btn btn-clean btn-sm btn-icon" onClick={() => console.log("cancel action to be discussed")}>
                        <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={''} />
                      </button>
                    </OverlayTrigger>
                      : <button onClick={changePlan} className="btn btn-primary btn-sm"> <span className="navi-text upgPlan" id="upgPlan"> Change Plan </span></button>}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="accordion-body p-0">
            <div id={`${item?.invoices?.length > 0 ? `allInvoice_of_w${index}` : ""}`} className="accordion-collapse invoice-data collapse">
              <table className="table m-0">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Invoice Id</th>
                    <th>Plan</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th align={"right"} style={{ textAlign: "right" }}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {item.invoices
                    ? item.invoices.map((invoiceItem, index) => (
                      <tr>
                        <td>
                          {moment(invoiceItem?.invoiceDate).format("DD MMM YYYY" )}
                        </td>
                        <td>
                          {invoiceItem?.invoiceView?.invoiceId}
                        </td>
                        <td>
                          {invoiceItem?.invoiceView?.item}
                        </td>
                        <td>
                          {invoiceItem?.invoiceView?.currencyValue}
                          {invoiceItem?.amount}
                        </td>
                        <td>
                          {invoiceItem?.status ? (
                            <span className="label font-weight-bold label-xl label-inline label-light-success plan_status">
                              Paid
                            </span>
                          ) : null}
                        </td>
                        <td align={"right"}>
                          <button type="button" className="btn btn-clean btn-sm btn-icon" onClick={() => openInvoicePopup(invoiceItem)}>
                            <FontAwesomeIcon type={'regular'} icon={'eye'} iconClass={''} />
                          </button>

                          {downloadLoading && invoiceId && invoiceId.length > 0 && invoiceId.includes(invoiceItem.invoiceId) ?
                            <button className='ms-2 loader-button'>
                              <Loader type="ThreeDots" color="#333333" height={18} width={18} />
                            </button> :
                            <button
                              type="button"
                              className="btn btn-clean btn-sm btn-icon ms-2"
                              onClick={downloadInvoicePDF(
                                invoiceItem.invoiceId,
                                invoiceItem.invoiceView.invoiceId
                              )}>
                              <FontAwesomeIcon type={'regular'} icon={'arrow-down-to-bracket'} iconClass={''} />
                            </button>}
                        </td>
                      </tr>
                    ))
                    : null}
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div> </> : null
}